<template>
    <div class="explanation-container">
        <div class="scenario-context">
            <div class="customer-action-card">
                <div class="d-flex align-center justify-center flex-wrap gap-2 mb-2">
                    <v-icon
                        color="success"
                        size="24"
                        aria-hidden="true"
                    >
                        mdi-check-circle
                    </v-icon>
                    <h3 class="success--text text-h6">
                        Bulk Message Campaign Initiated - "Spring Cleaning"
                    </h3>
                </div>
                <p class="mb-1"><strong>Sample Customer:</strong> {{ customer_data.full_name }}</p>
                <p class="mb-0"><strong>Phone on File:</strong> {{ customer_data.phone }}</p>
            </div>
        </div>

        <div>
            <h3 class="text-h5 text-left mb-3">Here's what happens next ...</h3>
            <ul class="explanation-points">
                <li
                    v-for="(point, idx) in explanation_points"
                    :key="idx"
                    class="explanation-point"
                >
                    <v-icon
                        color="primary"
                        size="28"
                        class="point-icon"
                        aria-hidden="true"
                    >
                        mdi-chevron-right
                    </v-icon>
                    <p class="explanation-text">{{ point }}</p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        customer_data: {
            type: Object,
            required: true
        },
        business_name: {
            type: String,
            required: true
        }
    },

    computed: {
        explanation_points() {
            const nickname = this.customer_data?.customer_nickname || 'the customer';
            return [
                `${this.business_name} sends an SMS to ${nickname} as part of the campaign, asking her to review her contact information on file to ensure it's up to date`,
                `The message includes a personalized link that directs ${nickname} to a secure web page with her current information`
            ];
        }
    }
}
</script>

<style lang="scss" scoped>
    .customer-action-card {
        background: var(--color-bg-shaded-light);
        border: 2px solid #e9ecef;
        border-radius: 12px;
        padding: 1.5rem;
        text-align: center;
        color: var(--color-text);
        font-size: 0.95rem;
    }
</style>
